import React from "react";
import '../styles/home.css';
import Carousel from '../components/Carousel';
import Ring from '../components/ring';
import ImageCarousel from '../components/ImagesCarousel';
import { Link } from 'react-router-dom';

const slides = [
  {
    imageUrl: "/jewleryCouple.png",
    title: "Slide Title",
    description: "AUTHENTIC ANCIENT COIN JEWELLERY",
    buttonText: "SHOP NOW",
    buttonLink: "/shop",
    textPosition: "bottom" // or "bottom"
  },
  {
    imageUrl: "/circeBlock.png",
    title: "Slide Title",
    description: "HISTORY MEETS CRAFTSMANSHIP",
    buttonText: "LEARN MORE",
    buttonLink: "/about",
    textPosition: "top" // or "bottom"

  },
  {
    imageUrl: "/handJewlery.png",
    title: "Slide Title",
    description: "UNIQUE MEANINGFUL PIECES",
    buttonText: "SHOP BESPOKE",
    buttonLink: "/contact",
    textPosition: "bottom" // or "bottom"
  },
  
  // ... more slides
];

const images = [
  "/watchChain.jpg",
  "/malePendant.jpg",
  "/forge.jpg",
  "/femalePendant.jpg",
  "/pendant.JPG",
];

const Home = () => {


  return (
    <div className="max-w-full mx-auto">
      {/* Hero Section */}
      

      <div className="relative h-[600px] w-100vh mb-16">
        <Carousel slides={slides} />

      </div>

      {/* About Section */}
      <div className="px-8">
        <div className="max-w-6xl mx-auto text-center">
        <p className="md:text-3xl text-xl font-semibold italic mb-8 custom-font-text">
            At Circe's Forge, we believe in the power of storytelling through art.
          </p>
          <div className="rounded-t-sm py-8 md:pb-16">
            <p className="text-xl bold mx-4 custom-font-text">
              We are a small Calgary, Alberta based business dedicated to creating one-of-a-kind jewellery pieces 
              that blend the timeless beauty of authentic ancient coins with the artistry of hand-forged chains. 
              Each piece is infused with passion, care, and a deep respect for history.
            </p>
          </div>
        </div>
      </div>
      <div className="px-8 bg-accent max-w-6xl mx-auto rounded-b-sm justify-center pt-8 mt-2 md:mt-0">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-2xl font-semibold italic mb-8 custom-font-text text-white">
            Browse our collections or contact us to choose your own ancient coin talisman:
          </p>
          <div className="flex md:flex-row flex-col justify-center gap-16">
            <Ring frontImage="/pendants.JPG" linkPath="/shop/ancient-coin-pendant" buttonText="COIN PENDANTS" />
            <Ring frontImage="/chain.jpg" linkPath="/shop/necklace" buttonText="CHAINS" />
            <Ring frontImage="/allCreations.png" linkPath="/shop" buttonText="ALL CREATIONS" />
          </div>
        </div>
      </div>
      <div className="">
        <div className="max-w-6xl mx-auto text-center px-8">
          <p className="text-2xl italic my-8 mx-4">
          We source authentic, centuries-old coins from reputable auction houses and numismatists worldwide.  These amazing artifacts have witnessed the rise and fall of empires, capturing intricate symbolism and the unique character of their time. We pair these ~2000 year old coins with hand forged designs, in oxidised sterling silver (sometimes with touches of gold), giving you an heirloom piece that could have been crafted in those bygone times.
          </p>
        </div>
        <p className="text-3xl font-bold italic text-center custom-font-text my-8 mb-4">
        Where Precious Metals, Fire and History Alloy
        </p>
        <div className="flex flex-row justify-center items-center bg-gradient-to-t from-primary to-accent to-99% py-2">
          <div className="max-w-7xl w-full mx-auto">
            <ImageCarousel images={images} />
          </div>
        </div>
      </div>
      <div className="flex justify-center my-8">
        <Link 
          to="/shop"
          className="bg-transparent border-2 border-accent text-accent text-xl px-12 py-4 rounded-full hover:bg-accent hover:bg-opacity-40 transition-all duration-300 font-bold-md"
        >
          SHOP ALL
        </Link>
      </div>

    </div>
  );
};

export default Home;
